exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.account-desc span label[data-v-c7a6ef66] {\n    color: #FF324D;\n}\n.account-desc[data-v-c7a6ef66] {\n    padding-bottom: 30px;\n    border-bottom: 1px solid #dee2e6;\n    margin-bottom: 40px;\n}\n[data-v-c7a6ef66] .account-desc p {\n    color: #FF324D;\n    line-height: unset;\n    margin-bottom: 0;\n}\n", ""]);

// exports
